// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function empty(param) {
  return {
          id: undefined,
          value: undefined,
          min: undefined,
          max: undefined
        };
}

function id(t) {
  return t.id;
}

function value(t) {
  return t.value;
}

function min(t) {
  return t.min;
}

function max(t) {
  return t.max;
}

function setMin(t, min) {
  return {
          id: t.id,
          value: t.value,
          min: min,
          max: t.max
        };
}

function setMax(t, max) {
  return {
          id: t.id,
          value: t.value,
          min: t.min,
          max: max
        };
}

function decode(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          value: Json_decode.optional((function (param) {
                  return Json_decode.field("value", Json_decode.$$int, param);
                }), json),
          min: Json_decode.optional((function (param) {
                  return Json_decode.field("min", Json_decode.$$int, param);
                }), json),
          max: Json_decode.optional((function (param) {
                  return Json_decode.field("max", Json_decode.$$int, param);
                }), json)
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "min",
                  Json_encode.nullable((function (prim) {
                          return prim;
                        }), t.min)
                ],
                tl: {
                  hd: [
                    "max",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), t.max)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

var dataTypeName = "NumberType";

exports.empty = empty;
exports.dataTypeName = dataTypeName;
exports.id = id;
exports.value = value;
exports.min = min;
exports.max = max;
exports.setMin = setMin;
exports.setMax = setMax;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
